<template>
  <header class="header">
    <div class="container">
      <nav class="nav">
        <div class="nav-brand">
          <router-link to="/" class="brand-link">
            <div class="logo">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="18" height="18" rx="3" stroke="#667eea" stroke-width="2"/>
                <path d="M12 8v8M8 12h8" stroke="#667eea" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <span class="brand-text">Docker1s</span>
          </router-link>
        </div>

        <div class="nav-menu" :class="{ 'nav-menu-active': isMenuOpen }">
          <router-link to="/" class="nav-link" @click="closeMenu">{{ $t('nav.home') }}</router-link>
          <router-link to="/docs" class="nav-link" @click="closeMenu">{{ $t('nav.docs') }}</router-link>
          <router-link to="/status" class="nav-link" @click="closeMenu">{{ $t('nav.status') }}</router-link>
          <router-link to="/about" class="nav-link" @click="closeMenu">{{ $t('nav.about') }}</router-link>
          <a href="#" class="nav-link" @click="closeMenu">{{ $t('nav.blog') }}</a>

          <!-- 移动端时，将操作按钮移到菜单内部 -->
          <div class="nav-actions mobile-actions">
            <!-- 语言切换 -->
            <div class="language-switcher">
              <button class="language-btn" @click="toggleLanguageMenu">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <path d="M8 14s1.5 2 4 2 4-2 4-2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <path d="M9 9h.01M15 9h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
                {{ currentLanguage }}
              </button>
              <div class="language-menu" v-show="showLanguageMenu">
                <button class="language-option" @click="changeLanguage('zh-CN')">中文</button>
                <button class="language-option" @click="changeLanguage('en-US')">English</button>
              </div>
            </div>

            <!-- 登录/用户状态 -->
            <div class="user-section">
              <div v-if="!isLoggedIn" class="auth-buttons">
                <button class="btn btn-ghost" @click="showLoginModal">{{ $t('common.login') }}</button>
                <button class="btn btn-primary" @click="showRegisterModal">{{ $t('common.register') }}</button>
              </div>
              <div v-else class="user-menu">
                <div class="user-avatar" @click="toggleUserMenu">
                  <img :src="user.avatar" :alt="user.name" v-if="user.avatar">
                  <div v-else class="avatar-placeholder">{{ user.name?.charAt(0) || 'U' }}</div>
                </div>
                <div class="user-dropdown" v-show="showUserMenu">
                  <div class="user-info">
                    <div class="user-name">{{ user.name }}</div>
                    <div class="user-email">{{ user.email }}</div>
                  </div>
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"/>
                      <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    {{ $t('common.profile') }}
                  </a>
                  <a href="#" class="dropdown-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    {{ $t('common.settings') }}
                  </a>
                  <div class="dropdown-divider"></div>
                  <a href="#" class="dropdown-item" @click="logout">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2"/>
                      <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2"/>
                      <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    {{ $t('common.logout') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 桌面端的操作按钮 -->
        <div class="nav-actions desktop-actions">
          <!-- 语言切换 -->
          <div class="language-switcher">
            <button class="language-btn" @click="toggleLanguageMenu">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M8 14s1.5 2 4 2 4-2 4-2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M9 9h.01M15 9h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              {{ currentLanguage }}
            </button>
            <div class="language-menu" v-show="showLanguageMenu">
              <button class="language-option" @click="changeLanguage('zh-CN')">中文</button>
              <button class="language-option" @click="changeLanguage('en-US')">English</button>
            </div>
          </div>

          <!-- 登录/用户状态 -->
          <div class="user-section">
            <div v-if="!isLoggedIn" class="auth-buttons">
              <button class="btn btn-ghost" @click="showLoginModal">{{ $t('common.login') }}</button>
              <button class="btn btn-primary" @click="showRegisterModal">{{ $t('common.register') }}</button>
            </div>
            <div v-else class="user-menu">
              <div class="user-avatar" @click="toggleUserMenu">
                <img :src="user.avatar" :alt="user.name" v-if="user.avatar">
                <div v-else class="avatar-placeholder">{{ user.name?.charAt(0) || 'U' }}</div>
              </div>
              <div class="user-dropdown" v-show="showUserMenu">
                <div class="user-info">
                  <div class="user-name">{{ user.name }}</div>
                  <div class="user-email">{{ user.email }}</div>
                </div>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2"/>
                    <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  {{ $t('common.profile') }}
                </a>
                <a href="#" class="dropdown-item">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  {{ $t('common.settings') }}
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" class="dropdown-item" @click="logout">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2"/>
                    <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2"/>
                    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2"/>
                  </svg>
                  {{ $t('common.logout') }}
                </a>
              </div>
            </div>
          </div>
        </div>

        <button class="mobile-menu-toggle" @click="toggleMenu">
          <span class="hamburger"></span>
        </button>
      </nav>
    </div>

    <!-- 登录弹窗 -->
    <AuthModal
      :visible="showAuthModal"
      :initial-mode="authMode"
      @close="closeAuthModal"
      @login-success="handleLoginSuccess"
      @register-success="handleRegisterSuccess"
    />
  </header>
</template>

<script>
import AuthModal from './AuthModal.vue'

export default {
  name: 'Header',
  components: {
    AuthModal
  },
  data() {
    return {
      isMenuOpen: false,
      showLanguageMenu: false,
      showUserMenu: false,
      showAuthModal: false,
      authMode: 'login',
      isLoggedIn: false, // 模拟登录状态
      user: {
        name: '张三',
        email: 'zhangsan@example.com',
        avatar: null
      }
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale === 'zh-CN' ? '中文' : 'English'
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
    },
    toggleLanguageMenu() {
      this.showLanguageMenu = !this.showLanguageMenu
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
    },
    changeLanguage(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
      this.showLanguageMenu = false
      // 在移动端时，切换语言后关闭菜单
      if (window.innerWidth <= 768) {
        this.closeMenu()
      }
    },

    showLoginModal() {
      this.authMode = 'login'
      this.showAuthModal = true
      // 在移动端时，显示登录弹窗后关闭菜单
      if (window.innerWidth <= 768) {
        this.closeMenu()
      }
    },
    showRegisterModal() {
      this.authMode = 'register'
      this.showAuthModal = true
      // 在移动端时，显示注册弹窗后关闭菜单
      if (window.innerWidth <= 768) {
        this.closeMenu()
      }
    },
    closeAuthModal() {
      this.showAuthModal = false
    },
    handleLoginSuccess(userData) {
      this.isLoggedIn = true
      this.user = {
        ...userData,
        avatar: null
      }
      console.log('Login successful:', userData)
    },
    handleRegisterSuccess(userData) {
      this.isLoggedIn = true
      this.user = {
        ...userData,
        avatar: null
      }
      console.log('Registration successful:', userData)
    },
    logout() {
      this.isLoggedIn = false
      this.showUserMenu = false
      this.user = {}
      // 清除登录状态
      console.log('User logged out')
    }
  },
  mounted() {
    // 点击外部区域关闭下拉菜单
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showLanguageMenu = false
        this.showUserMenu = false
      }
    })
  }
}
</script>

<style scoped>
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
}

.nav-brand {
  display: flex;
  align-items: center;
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-weight: 600;
  font-size: 1.25rem;
}

.logo {
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
}

.brand-text {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-menu-active {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.nav-link {
  text-decoration: none;
  color: #666;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
}

.nav-link:hover,
.nav-link.router-link-active {
  color: #667eea;
}

.nav-link.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  right: 0;
  height: 2px;
  background: #667eea;
  border-radius: 1px;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* 语言切换器 */
.language-switcher {
  position: relative;
}

.language-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}

.language-btn:hover {
  border-color: #667eea;
  color: #667eea;
}

.language-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  min-width: 120px;
  overflow: hidden;
  z-index: 1001;
}

.language-option {
  display: block;
  width: 100%;
  padding: 0.75rem 1rem;
  background: none;
  border: none;
  text-align: left;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.language-option:hover {
  background: #f8fafc;
  color: #667eea;
}

/* 用户区域 */
.user-section {
  position: relative;
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 0.875rem;
}

.btn-ghost {
  background: transparent;
  color: #666;
  border: 1px solid #e5e7eb;
}

.btn-ghost:hover {
  color: #667eea;
  border-color: #667eea;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: 1px solid transparent;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

/* 用户菜单 */
.user-menu {
  position: relative;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid #e5e7eb;
  transition: border-color 0.3s ease;
}

.user-avatar:hover {
  border-color: #667eea;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.875rem;
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  overflow: hidden;
  z-index: 1001;
  margin-top: 0.5rem;
}

.user-info {
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
}

.user-email {
  font-size: 0.875rem;
  color: #666;
}

.dropdown-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0.5rem 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  color: #666;
  text-decoration: none;
  transition: all 0.3s ease;
}

.dropdown-item:hover {
  background: #f8fafc;
  color: #667eea;
}

.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
}

.hamburger {
  display: block;
  width: 20px;
  height: 2px;
  background: #333;
  position: relative;
  transition: all 0.3s ease;
}

.hamburger::before,
.hamburger::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 2px;
  background: #333;
  transition: all 0.3s ease;
}

.hamburger::before {
  top: -6px;
}

.hamburger::after {
  bottom: -6px;
}

/* 默认显示桌面端操作按钮，隐藏移动端 */
.mobile-actions {
  display: none;
}

.desktop-actions {
  display: flex;
}

@media (max-width: 768px) {
  /* 在移动端隐藏桌面操作按钮，显示移动端 */
  .desktop-actions {
    display: none;
  }

  .mobile-actions {
    display: flex;
  }

  .nav-menu {
    position: fixed;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    padding: 2rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    z-index: 1002;
    align-items: stretch;
    gap: 1rem;
  }

  .nav-menu-active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-actions {
    position: relative;
    top: auto;
    right: auto;
    background: transparent;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    gap: 0.75rem;
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #f0f0f0;
  }

  /* 在移动端，将nav-actions整合到nav-menu中 */
  .nav-menu .nav-actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .mobile-menu-toggle {
    display: block;
  }

  .language-switcher {
    margin-bottom: 1rem;
  }

  .language-btn {
    width: 100%;
    justify-content: center;
  }

  .auth-buttons {
    flex-direction: column;
    gap: 0.75rem;
  }

  .auth-buttons .btn {
    width: 100%;
    justify-content: center;
  }

  .language-menu,
  .user-dropdown {
    position: static;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 0.5rem;
  }
}

/* 深色模式 */
:global(.dark-mode) .header {
  background: rgba(17, 24, 39, 0.95);
  border-bottom-color: #374151;
}

:global(.dark-mode) .brand-link,
:global(.dark-mode) .nav-link {
  color: #f3f4f6;
}

:global(.dark-mode) .nav-link:hover,
:global(.dark-mode) .nav-link.router-link-active {
  color: #667eea;
}

:global(.dark-mode) .language-btn,
:global(.dark-mode) .btn-ghost {
  border-color: #4b5563;
  color: #f3f4f6;
}

:global(.dark-mode) .language-menu,
:global(.dark-mode) .user-dropdown {
  background: #1f2937;
  border-color: #374151;
}

:global(.dark-mode) .language-option,
:global(.dark-mode) .dropdown-item {
  color: #f3f4f6;
}

:global(.dark-mode) .language-option:hover,
:global(.dark-mode) .dropdown-item:hover {
  background: #374151;
}
</style>
